import { Loader } from '../utils/loader.js';
import { sleep, animateCSS, vis } from '../utils/helpers';
import Swiper, { Navigation, Pagination, Scrollbar } from 'swiper';

export default class BtLocations {

    constructor() {
        this.addEvents();
    }

    addEvents() {
        $( document ).ready(function() {
            if($('section').hasClass('bt-location')){
                let parent = $('.bt-location__list');
                generateColumns(parent, $('.bt-location__item').length);

                let swiperOptions = {};
                swiperOptions.slidesPerView = 'auto';
                swiperOptions.modules = [Navigation, Pagination, Scrollbar];
                // swiperOptions.scrollbar = {};
                swiperOptions.navigation = {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                };
                swiperOptions.freeMode = true;
                swiperOptions.slidesOffsetBefore = 10;
                swiperOptions.slidesOffsetAfter = 10;
                swiperOptions.breakpoints = {
                    1024: {
                        slidesOffsetBefore: 50,
                        slidesOffsetAfter: 50
                    },

                };
                swiperOptions.on = {
                    init: function () {
                        setTimeout(() => {
                            var totalWidth = 0;
                            this.slides.forEach(function (slide) {
                                totalWidth += slide.offsetWidth;
                            });
                            this.wrapperEl.style.width = totalWidth + 'px';
                        }, 1000);

                    },
                };
                const swiper = new Swiper('.bt-location__wrapp.swiper', swiperOptions);
                swiper.scrollbar.updateSize();
            }

            function generateColumns(container, totalElements) {
                let col = 1;
                let currentElement = 1;
                let allElement = $('.bt-location__item');
                let elementIndex = 0;

                while (currentElement <= totalElements) {
                    let elementCount = col === 1 || col % 4 === 0 ? 1 : 2;
                    let column = $(`<div class="swiper-slide column column-el-`+elementCount+`"></div>`);
                    for (let elem = 1; elem <= elementCount && currentElement <= totalElements; elem++) {
                        column.append(allElement[elementIndex]);
                        currentElement++;
                        elementIndex++;
                    }
                    container.append(column);
                    col++;
                }
            }
        })
    }

}